import React, { createContext, useState } from 'react'
import useFetchData from './customHooks/useFetchData';

const Context = createContext()

function ContextProvider({children}) {
    const { loading, setLoading, quizData, fetchData } = useFetchData()
    const [ quizScore, setScore ] = useState(0)  
    const [ nextButton, setNextButton ] = useState(false)
    const [ isNextPageShown ] = useState(false)
    const [ isScoreShown, setShowScore ] = useState(false)
    const [ isCorrect, setIsCorrect ] = useState(false)
    const [ isButtonClicked, setIsButtonClicked ] = useState(false)
    
    function handleClick(e) {
        const userGuess = e.target
        setIsButtonClicked(true)
        setNextButton(true)

        const buttons = Array.from(document.querySelectorAll(".btn"))
        const foundedAnswer = quizData.find(quiz => quiz.correctAnswer)
        
        if (userGuess.value === foundedAnswer.correctAnswer) {
            setScore(prev => prev + 1)
            userGuess.setAttribute('id','true')
            setIsCorrect(true)
            buttons.map(button => button.classList.add('disabledButton'))
        }
        
        if (userGuess.value !== foundedAnswer.correctAnswer) {
            userGuess.setAttribute('id','untrue')
            setIsCorrect(false)
            setTimeout(() => {
                const findTrueBtn = buttons.find(button => button.value === foundedAnswer.correctAnswer)
                findTrueBtn.setAttribute('id', 'true')
            }, 700);
            
            setShowScore(true)
            buttons.map(button => button.classList.add('disabledButton'))
        }       
        buttons.map(button => button.classList.add('stop-hovering'))

    }

    function handleNextButton (e) {
        setNextButton(false)
        setLoading(true)
        fetchData()
        
    }
    
    function handleTryAgain(e) {
        setNextButton(false)
        setLoading(true)
        fetchData()    
        setScore(0)
    }

    return (
        <Context.Provider 
            value={{
                loading,
                isCorrect,
                quizData, 
                nextButton, 
                isNextPageShown, 
                quizScore, 
                isButtonClicked,
                setScore, 
                isScoreShown, 
                handleClick, 
                handleNextButton, 
                handleTryAgain
            }}
        >
            {children}
        </Context.Provider>
    )
}

export {ContextProvider, Context}
